import React from "react";

export default ({ t, onClick }) => (
    // this component is no longer used but remains empty because otherwise the default component would take its place
    <div className="absolute m-0 p-0"></div>
);
